module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPresentsChristmas@2x.c2eef6e.webp";